import { createTheme as Y, lighten as K, darken as Me, alpha as Z, useTheme as P, styled as Fe } from "@mui/material/styles";
import { grey as G, common as tt, red as nt } from "@mui/material/colors";
import { jsxs as d, jsx as e, Fragment as F } from "react/jsx-runtime";
import { Paper as H, Typography as M, Container as Pe, Grid as x, Link as ne, Button as j, FormGroup as rt, FormControlLabel as N, Checkbox as E, Switch as ot, Stack as T, Box as b, lighten as ee, Drawer as De, IconButton as U, Tooltip as ze, Card as Ee, CardActionArea as je, CircularProgress as it, Alert as at, useTheme as D, TextField as ct, FormControl as st, InputLabel as lt, OutlinedInput as dt, InputAdornment as mt, FormHelperText as ut, CardContent as ht, Menu as He, MenuItem as Ue, Divider as re, Skeleton as te, Avatar as pt, AppBar as gt, useMediaQuery as q, Toolbar as We, styled as xt, List as V, ListItemButton as oe, ListItemIcon as Ne, ListItemText as Ge, Collapse as yt, ListItem as ft, Pagination as bt } from "@mui/material";
import { useTranslation as $ } from "react-i18next";
import Re, { useState as k, useEffect as z, useRef as vt, createContext as Ve, useContext as X, forwardRef as Ct } from "react";
import { Table as kt } from "@gisce/react-formiga-table";
import { WhatsappShareButton as wt, WhatsappIcon as St, FacebookShareButton as It, FacebookIcon as _t, TelegramShareButton as Bt, TelegramIcon as Mt } from "react-share";
import { Close as Rt, ShareOutlined as Le, LocalOffer as Lt, Help as Tt, VisibilityOff as $t, Visibility as At, Menu as Ot, ExpandLess as Ft, ExpandMore as Pt, Attachment as Dt, Clear as zt, FileUpload as Et, Remove as jt, Add as Ht } from "@mui/icons-material";
import Ut from "@mui/icons-material/ContentCopy";
import Wt from "@mui/icons-material/Done";
import Xe from "react-markdown";
import Nt from "rehype-raw";
import Gt from "remark-gfm";
import Qe from "@mui/material/useMediaQuery";
import Vt from "@mui/icons-material/AccountCircle";
import Xt, { merge as Qt } from "lodash";
import Yt from "@mui/material/ListItem";
import Ye from "@mui/icons-material/Language";
import { NumericFormat as qt } from "react-number-format";
const Fn = (r) => {
  var i, a, o, c, l, s, m, u, g, p, y, C, v, _, h, f, S, w;
  let t = Y(void 0, {
    custom: {
      constants: {
        borderRadius: 0,
        borderRadiusMinor: 1
      }
    }
  });
  return t = Y(t, r), Y(t, {
    palette: {
      primary: {
        light: K(t.palette.primary.main, 0.3),
        dark: Me(t.palette.primary.main, 0.3)
      },
      secondary: {
        light: K(t.palette.secondary.main, 0.3),
        dark: Me(t.palette.secondary.main, 0.3)
      },
      // default: {...defaultColor(theme)},
      grey: {
        main: G[300],
        dark: G[400]
        // contrastText: "#000"
      }
      // black: {
      //   main: lighten(common.black, 0.3),
      // }
    },
    components: {
      MuiSwitch: {
        styleOverrides: {
          colorSecondary: {
            "&$checked": {
              color: t.palette.primary.main
            },
            "&$checked + $track": {
              backgroundColor: t.palette.primary.main
            }
          },
          track: {
            backgroundColor: t.palette.secondary.main
          }
        }
      },
      MuiButtonGroup: {
        variants: [
          {
            props: { variant: "contained" },
            style: {
              borderRadius: (a = (i = t.custom) == null ? void 0 : i.constants) == null ? void 0 : a.borderRadius
            }
          }
        ]
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: (c = (o = t.custom) == null ? void 0 : o.constants) == null ? void 0 : c.borderRadius
          }
        },
        variants: [
          {
            props: { variant: "contained", color: "grey" },
            style: {
              color: t.palette.getContrastText(t.palette.grey[300])
            }
          },
          {
            props: { variant: "outlined", color: "grey" },
            style: {
              color: t.palette.text.primary,
              borderColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)",
              "&.Mui-disabled": {
                border: `1px solid ${t.palette.action.disabledBackground}`
              },
              "&:hover": {
                borderColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)",
                backgroundColor: Z(
                  t.palette.text.primary,
                  t.palette.action.hoverOpacity
                )
              }
            }
          },
          {
            props: { variant: "text", color: "grey" },
            style: {
              color: t.palette.text.primary,
              "&:hover": {
                backgroundColor: Z(
                  t.palette.text.primary,
                  t.palette.action.hoverOpacity
                )
              }
            }
          }
        ]
      },
      MuiPaper: {
        styleOverrides: {
          rounded: {
            borderRadius: (s = (l = t.custom) == null ? void 0 : l.constants) == null ? void 0 : s.borderRadius
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            minHeight: ((u = (m = t.custom) == null ? void 0 : m.constants) == null ? void 0 : u.appBarHeightMobile) ?? 64,
            [t.breakpoints.up("lg")]: {
              minHeight: ((p = (g = t.custom) == null ? void 0 : g.constants) == null ? void 0 : p.appBarHeightLaptop) ?? 64
            }
          },
          colorPrimary: {
            // https://stackoverflow.com/questions/56224684/material-ui-v4-appbar-wont-change-theme
            // defaultTheme.overrides.MuiAppBar.colorPrimary.backgroundColor
            backgroundColor: ((C = (y = t.custom) == null ? void 0 : y.constants) == null ? void 0 : C.appBarBackgroundColor) ?? t.palette.primary.main
          }
        }
      },
      MuiFormControl: {
        defaultProps: {
          variant: "standard"
        }
      },
      MuiTextField: {
        defaultProps: {
          variant: "standard"
        }
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            backgroundColor: t.palette.secondary.main
          }
        }
      },
      MuiList: {
        defaultProps: {
          dense: !0
        }
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: (_ = (v = t.custom) == null ? void 0 : v.constants) == null ? void 0 : _.borderRadiusMinor,
            overflow: "hidden"
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            borderRadius: (f = (h = t.custom) == null ? void 0 : h.constants) == null ? void 0 : f.borderRadiusMinor,
            overflow: "hidden"
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            borderRadius: (w = (S = t.custom) == null ? void 0 : S.constants) == null ? void 0 : w.borderRadiusMinor,
            overflow: "hidden"
          }
        }
      }
    },
    custom: {
      constants: {
        defaultButtonColor: "grey",
        logoBarMaxHeightImage: 64
      },
      components: {
        reactFormigaTable: {
          onRowStyle: () => ({}),
          style: {
            containerStyle: {
              width: "100%",
              boxShadow: "0 1.5px 5px #80808094"
            },
            tableStyle: {
              whiteSpace: "inherit",
              userSelect: "inherit"
            },
            headerStyle: {
              backgroundColor: "#f0f0f0",
              cursor: "pointer",
              rftLabel: {
                justifyContent: "flex-start"
              },
              zIndex: 1
            },
            cellStyle: {
              rftLabel: {
                color: tt.black,
                fontSize: "0.8rem",
                fontWeight: 200
              },
              userSelect: "text"
            }
          }
        },
        hoverElement: {
          border: "1px solid lightgrey",
          background: `linear-gradient(
            217deg,
            rgba(230,230,230, 1) 0%,
            rgba(240,240,240, 1) 100%
          );`,
          backgroundHover: "lightGrey",
          borderHover: "1px solid grey"
        },
        // publicityBanner: {
        //   stylingProps: {
        //     containerSx: {
        //       borderRadius: theme.custom?.constants?.borderRadius,
        //     }
        //   }
        // },
        languageSelect: {
          buttonStyle: {
            color: "inherit"
          }
        },
        pageContainer: {
          paper: {
            elevation: 5
          }
        }
      }
    }
  });
}, Pn = ({
  cookiePolicyHref: r,
  acceptCookies: n,
  personalizeCookies: t
}) => {
  const { t: i } = $();
  return /* @__PURE__ */ d(H, { elevation: 24, style: { padding: 30 }, children: [
    /* @__PURE__ */ e(M, { variant: "h4", children: i("common:text.cookie_consent_title") }),
    /* @__PURE__ */ e(M, { children: i("common:text.cookie_consent_text") }),
    /* @__PURE__ */ e(Pe, { children: /* @__PURE__ */ d(x, { container: !0, spacing: 2, justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ e(x, { item: !0, xs: 12, style: { textAlign: "center" }, children: /* @__PURE__ */ e(ne, { variant: "button", href: r, target: "_blank", rel: "noreferrer", children: i("common:text.cookie_policy_text") }) }),
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(
        j,
        {
          color: "primary",
          variant: "contained",
          className: "container-element",
          onClick: () => {
            n("all");
          },
          children: i("common:text.cookie_accept_all_text")
        }
      ) }),
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(
        j,
        {
          variant: "contained",
          className: "container-element",
          onClick: t,
          children: i("common:text.cookie_decide_which_text")
        }
      ) })
    ] }) })
  ] });
}, Dn = ({
  cookiePolicyHref: r,
  acceptCookies: n
}) => {
  const { t } = $(), [i, a] = k({
    consent: !0,
    preferences: !1,
    statistics: !1,
    marketing: !1
  }), o = (c) => {
    a({ ...i, [c.target.name]: c.target.checked });
  };
  return /* @__PURE__ */ d(H, { elevation: 24, style: { padding: 30 }, children: [
    /* @__PURE__ */ e(M, { variant: "h4", children: t("common:text.cookie_consent_title") }),
    /* @__PURE__ */ e(M, { children: t("common:text.cookie_consent_text") }),
    /* @__PURE__ */ d(rt, { row: !0, style: { justifyContent: "center" }, children: [
      /* @__PURE__ */ e(
        N,
        {
          control: /* @__PURE__ */ e(E, { checked: i.consent, onChange: o, name: "consent" }),
          label: t("common:text.cookie_necessary_text")
        }
      ),
      /* @__PURE__ */ e(
        N,
        {
          control: /* @__PURE__ */ e(E, { checked: i.preferences, onChange: o, name: "preferences" }),
          label: t("common:text.cookie_preferences_text")
        }
      ),
      /* @__PURE__ */ e(
        N,
        {
          control: /* @__PURE__ */ e(E, { checked: i.statistics, onChange: o, name: "statistics" }),
          label: t("common:text.cookie_statistics_text")
        }
      ),
      /* @__PURE__ */ e(
        N,
        {
          control: /* @__PURE__ */ e(E, { checked: i.marketing, onChange: o, name: "marketing" }),
          label: t("common:text.cookie_marketing_text")
        }
      )
    ] }),
    /* @__PURE__ */ e(Pe, { children: /* @__PURE__ */ d(x, { container: !0, spacing: 2, justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(ne, { variant: "button", href: r, target: "_blank", rel: "noreferrer", children: t("common:text.cookie_policy_text") }) }),
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(
        j,
        {
          variant: "contained",
          className: "container-element",
          onClick: () => n(i),
          children: t("common:text.cookie_consent_button")
        }
      ) })
    ] }) })
  ] });
}, zn = ({
  columns: r,
  dataSource: n,
  loading: t = !1,
  loadingComponent: i,
  onRowStatus: a,
  sorter: o
}) => {
  var l, s, m, u, g, p;
  const c = P();
  return /* @__PURE__ */ e(
    kt,
    {
      columns: r,
      dataSource: n,
      loading: t,
      onRowStatus: a,
      loadingComponent: i,
      onRowStyle: (m = (s = (l = c.custom) == null ? void 0 : l.components) == null ? void 0 : s.reactFormigaTable) == null ? void 0 : m.onRowStyle,
      readonly: !0,
      sorter: o,
      customStyle: (p = (g = (u = c.custom) == null ? void 0 : u.components) == null ? void 0 : g.reactFormigaTable) == null ? void 0 : p.style
    }
  );
}, En = ({
  labelLeft: r,
  labelRight: n,
  checked: t,
  onChange: i,
  ...a
}) => {
  const [o, c] = k(t), l = (s) => {
    c(s.target.checked), i(s.target.checked);
  };
  return z(() => {
    c(t);
  }, [t]), /* @__PURE__ */ d(x, { container: !0, alignItems: "center", children: [
    /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(M, { sx: { opacity: o ? 0.5 : 1 }, children: r }) }),
    /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(
      ot,
      {
        checked: o,
        onChange: l,
        inputProps: { "aria-label": `Switch ${r} - ${n}` },
        ...a
      }
    ) }),
    /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(M, { sx: { opacity: o ? 1 : 0.5 }, children: n }) })
  ] });
}, jn = ({
  children: r,
  breakpoint: n = "lg",
  maxWidth: t = "90vw",
  upBreakpointSx: i,
  downBreakpointSx: a,
  wrapperComponent: o,
  wrapperProps: c = {}
}) => {
  var m, u, g;
  const l = P();
  o || (o = ({ children: p, ...y }) => /* @__PURE__ */ e(
    H,
    {
      ...y,
      children: p
    }
  ));
  const s = {
    width: "100%",
    [l.breakpoints.down(n)]: {
      borderRadius: 0,
      flex: 1,
      ...a
    },
    [l.breakpoints.up(n)]: {
      maxWidth: t,
      ...i
    },
    ...(g = (u = (m = l.custom) == null ? void 0 : m.components) == null ? void 0 : u.pageContainer) == null ? void 0 : g.back,
    ..."sx" in c && c.sx
  };
  return /* @__PURE__ */ e(T, { alignItems: "center", height: "100%", children: /* @__PURE__ */ e(
    o,
    {
      ...c,
      sx: s,
      children: r
    }
  ) });
}, Hn = ({
  children: r,
  color: n = "default",
  background: t,
  backgroundHover: i,
  border: a,
  borderHover: o,
  ...c
}) => {
  const l = vt(null), [s, m] = k({ x: 0, y: 0 }), u = P(), [g, p] = k(!1), y = (L) => {
    if (!l.current) return;
    const I = l.current.getBoundingClientRect();
    m({ x: L.clientX - I.left, y: L.clientY - I.top });
  }, C = () => {
    p(!0);
  }, v = () => {
    p(!1);
  }, { sx: _, ...h } = c, f = () => {
    var B, I, R;
    const L = a ?? ((R = (I = (B = u.custom) == null ? void 0 : B.components) == null ? void 0 : I.hoverElement) == null ? void 0 : R.border);
    switch (n) {
      default:
        return L;
    }
  }, S = () => {
    var B, I, R;
    const L = t ?? ((R = (I = (B = u.custom) == null ? void 0 : B.components) == null ? void 0 : I.hoverElement) == null ? void 0 : R.background);
    switch (n) {
      default:
        return L;
    }
  }, w = () => {
    var B, I, R;
    const L = i ?? ((R = (I = (B = u.custom) == null ? void 0 : B.components) == null ? void 0 : I.hoverElement) == null ? void 0 : R.backgroundHover);
    switch (n) {
      case "primary":
        return `${ee(u.palette.primary.main, 0.75)};`;
      case "secondary":
        return `${ee(u.palette.secondary.main, 0.75)};`;
      default:
        return L;
    }
  }, A = () => {
    var B, I, R;
    const L = o ?? ((R = (I = (B = u.custom) == null ? void 0 : B.components) == null ? void 0 : I.hoverElement) == null ? void 0 : R.borderHover);
    switch (n) {
      case "primary":
        return `1px solid ${u.palette.primary.main}`;
      case "secondary":
        return `1px solid ${u.palette.secondary.main}`;
      default:
        return L;
    }
  };
  return /* @__PURE__ */ d(
    b,
    {
      sx: {
        width: "100%",
        position: "relative",
        ..._
      },
      onMouseMove: y,
      onMouseEnter: C,
      onMouseLeave: v,
      ref: l,
      ...h,
      children: [
        /* @__PURE__ */ e(
          b,
          {
            sx: {
              border: f(),
              borderRadius: "inherit",
              background: S(),
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 1
            }
          }
        ),
        /* @__PURE__ */ e(
          b,
          {
            sx: {
              borderRadius: "inherit",
              background: w(),
              maskImage: `radial-gradient(500px at ${s.x}px ${s.y}px, black 10%, transparent)`,
              opacity: g ? 1 : 0,
              transition: "all 1s",
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }
          }
        ),
        /* @__PURE__ */ e(
          b,
          {
            sx: {
              border: A(),
              borderRadius: "inherit",
              opacity: g ? 1 : 0,
              transition: "all 1s",
              maskImage: `radial-gradient(
              200px at ${s.x}px ${s.y}px, black 45%, transparent)`,
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 3
            }
          }
        ),
        /* @__PURE__ */ e(
          b,
          {
            sx: {
              border: "none",
              padding: 2,
              position: "inherit",
              zIndex: 4
            },
            children: r
          }
        )
      ]
    }
  );
}, Jt = ({ visible: r, onClose: n, url: t }) => {
  const { t: i } = $();
  return /* @__PURE__ */ d(De, { open: r, anchor: "bottom", onClose: n, style: { height: "100%" }, children: [
    /* @__PURE__ */ e(x, { container: !0, children: /* @__PURE__ */ d(x, { container: !0, item: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(M, { variant: "h5", style: { padding: "10px" }, children: i("common:text.share_more") }) }),
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(U, { "aria-label": "close", onClick: n, children: /* @__PURE__ */ e(Rt, { fontSize: "small" }) }) })
    ] }) }),
    /* @__PURE__ */ d(x, { item: !0, container: !0, style: { padding: "0 0 15px 15px" }, children: [
      /* @__PURE__ */ e(x, { item: !0, style: { marginRight: "10px" }, children: /* @__PURE__ */ e(wt, { url: t, children: /* @__PURE__ */ e(St, { round: !0 }) }) }),
      /* @__PURE__ */ e(x, { item: !0, style: { marginRight: "10px" }, children: /* @__PURE__ */ e(It, { url: t, children: /* @__PURE__ */ e(_t, { round: !0 }) }) }),
      /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(Bt, { url: t, children: /* @__PURE__ */ e(Mt, { round: !0 }) }) })
    ] })
  ] });
}, Kt = ({
  children: r,
  onClick: n,
  ...t
}) => {
  const i = {
    button: /* @__PURE__ */ e(j, { startIcon: /* @__PURE__ */ e(Le, {}), onClick: n, ...t, children: r }),
    buttonIcon: /* @__PURE__ */ e(U, { onClick: n, ...t, children: /* @__PURE__ */ e(Le, {}) })
  };
  return r ? i.button : i.buttonIcon;
}, Zt = ({
  url: r,
  children: n,
  ...t
}) => {
  const [i, a] = k(!1), o = typeof navigator.share == "function", c = async (s) => {
    try {
      await navigator.share({ url: s });
    } catch (m) {
      console.error(m);
    }
  };
  return /* @__PURE__ */ d(F, { children: [
    /* @__PURE__ */ e(Kt, { onClick: () => {
      o ? c(r) : a(!0);
    }, ...t, children: n }),
    !o && /* @__PURE__ */ e(Jt, { visible: i, onClose: () => a(!1), url: r })
  ] });
}, en = ({
  labelText: r,
  copyValue: n,
  url: t,
  sx: i
}) => {
  const { t: a } = $(), [o, c] = k(!1), [l, s] = k(""), m = () => {
    l === "copy" && (c(!0), navigator.clipboard.writeText(n).then(
      () => setTimeout(() => {
        c(!1);
      }, 2500)
    ));
  };
  return /* @__PURE__ */ e(
    ze,
    {
      title: a(l === "copy" ? o ? "common:text.coupon_copied" : "common:text.coupon_copy" : "common:text.coupon_share"),
      arrow: !0,
      placement: "right",
      children: /* @__PURE__ */ e(Ee, { children: /* @__PURE__ */ e(
        je,
        {
          sx: { height: "100%", padding: 1 },
          onClick: m,
          disableRipple: l === "share",
          onMouseEnter: () => s("copy"),
          children: /* @__PURE__ */ d(x, { container: !0, alignItems: "stretch", justifyContent: "space-around", children: [
            /* @__PURE__ */ e(
              x,
              {
                item: !0,
                alignSelf: "center",
                sx: {
                  // overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  hyphens: "auto"
                },
                children: r
              }
            ),
            /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(
              U,
              {
                onClick: m,
                onMouseEnter: () => {
                  s("copy");
                },
                sx: i,
                children: o ? /* @__PURE__ */ e(Wt, {}) : /* @__PURE__ */ e(Ut, {})
              }
            ) }),
            t && /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(Zt, { url: t, onMouseEnter: () => {
              s("share");
            }, sx: i }) })
          ] })
        }
      ) })
    }
  );
}, O = ({
  children: r,
  color: n,
  loading: t = !1,
  disabled: i,
  startIcon: a,
  ...o
}) => {
  var l, s;
  const c = P();
  return n === void 0 && (n = ((s = (l = c.custom) == null ? void 0 : l.constants) == null ? void 0 : s.defaultButtonColor) ?? void 0), /* @__PURE__ */ e(
    j,
    {
      color: n,
      startIcon: t ? /* @__PURE__ */ e(it, { size: 25, color: "inherit" }) : a,
      disabled: i || t,
      ...o,
      children: r
    }
  );
}, qe = ({
  content: r,
  executeHooks: n
}) => (n && n(), /* @__PURE__ */ e(Xe, { remarkPlugins: [Gt], components: { p: "span" }, children: r })), tn = ({
  html: r
}) => /* @__PURE__ */ e(Xe, { rehypePlugins: [Nt], children: r }), Un = ({
  dataProps: {
    shareURL: r,
    title: n,
    description: t,
    infoURL: i
  },
  stylingProps: a = {}
}) => {
  var u, g, p, y, C, v, _, h, f, S, w, A, L, B, I, R, ie, ae, ce, se, le, de, me, ue, he, pe, ge, xe, ye, fe, be, ve, Ce, ke, we, Se, Ie, _e, Be;
  const o = P(), { t: c } = $(), l = () => {
    var W;
    (W = window.open(i, "_blank")) == null || W.focus();
  }, s = {
    ...((y = (p = (g = (u = o.custom) == null ? void 0 : u.components) == null ? void 0 : g.publicityBanner) == null ? void 0 : p.stylingProps) == null ? void 0 : y.containerSx) && (Array.isArray((h = (_ = (v = (C = o.custom) == null ? void 0 : C.components) == null ? void 0 : v.publicityBanner) == null ? void 0 : _.stylingProps) == null ? void 0 : h.containerSx) ? o.custom.components.publicityBanner.stylingProps.containerSx[0] : o.custom.components.publicityBanner.stylingProps.containerSx),
    ...Array.isArray(a.containerSx) ? a.containerSx[0] : a.containerSx
  }, m = {
    ...((L = (A = (w = (S = (f = o.custom) == null ? void 0 : f.components) == null ? void 0 : S.publicityBanner) == null ? void 0 : w.stylingProps) == null ? void 0 : A.informationButtonProps) == null ? void 0 : L.sx) && (Array.isArray((ae = (ie = (R = (I = (B = o.custom) == null ? void 0 : B.components) == null ? void 0 : I.publicityBanner) == null ? void 0 : R.stylingProps) == null ? void 0 : ie.informationButtonProps) == null ? void 0 : ae.sx) ? (me = (de = (le = (se = (ce = o.custom) == null ? void 0 : ce.components) == null ? void 0 : se.publicityBanner) == null ? void 0 : le.stylingProps) == null ? void 0 : de.informationButtonProps) == null ? void 0 : me.sx[0] : (xe = (ge = (pe = (he = (ue = o.custom) == null ? void 0 : ue.components) == null ? void 0 : he.publicityBanner) == null ? void 0 : pe.stylingProps) == null ? void 0 : ge.informationButtonProps) == null ? void 0 : xe.sx),
    ...Array.isArray((ye = a.informationButtonProps) == null ? void 0 : ye.sx) ? (fe = a.informationButtonProps) == null ? void 0 : fe.sx[0] : (be = a.informationButtonProps) == null ? void 0 : be.sx
  };
  return /* @__PURE__ */ e(
    H,
    {
      elevation: 0,
      sx: {
        backgroundColor: (W) => W.palette.primary.main,
        color: "white",
        ...s
      },
      children: /* @__PURE__ */ d(T, { sx: { pl: 4, pr: 4 }, justifyContent: "center", alignItems: "center", children: [
        /* @__PURE__ */ d(
          b,
          {
            sx: { mt: 2 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: a.titleColor ?? ((we = (ke = (Ce = (ve = o.custom) == null ? void 0 : ve.components) == null ? void 0 : Ce.publicityBanner) == null ? void 0 : ke.stylingProps) == null ? void 0 : we.titleColor) ?? "primary",
            children: [
              /* @__PURE__ */ e(Lt, { style: { padding: "5px", paddingRight: "10px" }, fontSize: "large" }),
              /* @__PURE__ */ e(M, { variant: "h5", sx: { fontWeight: 600 }, children: n.toLocaleUpperCase() })
            ]
          }
        ),
        /* @__PURE__ */ e(b, { sx: { fontWeight: 500, fontSize: 17 }, children: /* @__PURE__ */ e(qe, { content: t || "" }) }),
        /* @__PURE__ */ e(en, { labelText: r, copyValue: r, url: r }),
        i && /* @__PURE__ */ e(
          O,
          {
            startIcon: /* @__PURE__ */ e(Tt, {}),
            onClick: l,
            color: "secondary",
            ...(Be = (_e = (Ie = (Se = o.custom) == null ? void 0 : Se.components) == null ? void 0 : Ie.publicityBanner) == null ? void 0 : _e.stylingProps) == null ? void 0 : Be.informationButtonProps,
            ...a.informationButtonProps,
            sx: {
              margin: 2,
              ...m
            },
            children: c("common:text.coupon_more_info")
          }
        )
      ] })
    }
  );
}, nn = ({
  label: r,
  ...n
}) => /* @__PURE__ */ e(at, { elevation: 6, variant: "filled", ...n, children: r }), Je = ({
  image: r,
  b64: n,
  text: t = "",
  style: i
}) => {
  var o, c, l, s;
  const a = D();
  return r || (c = (o = a.custom) == null ? void 0 : o.constants) != null && c.logoImage || n ? /* @__PURE__ */ e(
    "img",
    {
      src: r ?? (n && `${"data:image/png;base64," + n}`) ?? ((s = (l = a.custom) == null ? void 0 : l.constants) == null ? void 0 : s.logoImage),
      alt: `${"Logo" + t}`,
      style: {
        maxWidth: "65vw",
        maxHeight: "85%",
        ...i
      }
    }
  ) : /* @__PURE__ */ e(M, { variant: "h6", noWrap: !0, className: "toolbar-app-name", children: t });
}, Wn = ({
  signUp: r,
  loading: n = !1,
  alertProps: t,
  onLogin: i,
  onSignUp: a,
  onReset: o
}) => {
  const { t: c } = $(), l = P(), [s, m] = k(!1), [u, g] = k(null), [p, y] = k(null), [C, v] = k(!1), _ = Qe(l.breakpoints.down("sm")), h = () => v((w) => !w), f = (w) => {
    w.preventDefault();
  }, S = (w) => {
    w.preventDefault(), u && p ? (m(!1), i(u, p)) : m(!0);
  };
  return /* @__PURE__ */ d(T, { direction: "column", alignItems: "center", justifyContent: "center", sx: { ...!_ && { padding: 3 } }, children: [
    /* @__PURE__ */ e(Je, { style: { maxWidth: "300px" } }),
    /* @__PURE__ */ e("form", { onSubmit: S, autoComplete: "false", children: /* @__PURE__ */ d(
      x,
      {
        container: !0,
        spacing: 2,
        justifyContent: "center",
        mt: 1,
        children: [
          /* @__PURE__ */ e(x, { item: !0, children: /* @__PURE__ */ e(M, { variant: "h5", children: c("common:text.login_view_title") }) }),
          t && /* @__PURE__ */ e(x, { item: !0, xs: 12, children: /* @__PURE__ */ e(
            nn,
            {
              className: "errorAlert",
              severity: t.severity || "",
              label: t.label
            }
          ) }),
          /* @__PURE__ */ e(x, { item: !0, xs: 12, children: /* @__PURE__ */ e(
            ct,
            {
              placeholder: c("common:text.login_view_field_email_hint"),
              label: c("common:text.login_view_field_email_title"),
              type: "text",
              id: "username",
              variant: "outlined",
              onChange: (w) => g(w.target.value),
              sx: { width: "100%" },
              disabled: n,
              error: s && !u,
              helperText: s && !u && c("common:text.empty_field")
            }
          ) }),
          /* @__PURE__ */ e(x, { item: !0, xs: 12, children: /* @__PURE__ */ d(st, { variant: "outlined", sx: { width: "100%" }, children: [
            /* @__PURE__ */ e(lt, { id: "password", children: c("common:text.login_view_field_password_title") }),
            /* @__PURE__ */ e(
              dt,
              {
                id: "password",
                type: C ? "text" : "password",
                value: p,
                onChange: (w) => y(w.target.value),
                disabled: n,
                label: c("common:text.login_view_field_password_title"),
                error: !!(s && !p),
                endAdornment: /* @__PURE__ */ e(mt, { position: "end", children: /* @__PURE__ */ e(
                  U,
                  {
                    onClick: h,
                    onMouseDown: f,
                    onMouseUp: f,
                    edge: "end",
                    children: C ? /* @__PURE__ */ e($t, {}) : /* @__PURE__ */ e(At, {})
                  }
                ) })
              }
            ),
            s && !p && /* @__PURE__ */ e(ut, { error: !0, children: c("common:text.empty_field") })
          ] }) }),
          /* @__PURE__ */ e(x, { item: !0, xs: 12, children: /* @__PURE__ */ e(b, { display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ e(O, { onClick: o, variant: "text", color: "primary", disabled: n, size: "small", children: c("common:text.login_view_reset_password") }) }) }),
          /* @__PURE__ */ e(x, { item: !0, xs: 12, children: /* @__PURE__ */ e(
            O,
            {
              type: "submit",
              color: "primary",
              variant: "contained",
              loading: n,
              style: { width: "100%" },
              disabled: n,
              children: c(n ? "common:text.authenticating" : "common:text.login_view_button_send")
            }
          ) }),
          r && /* @__PURE__ */ d(x, { item: !0, style: { fontSize: "15px" }, children: [
            /* @__PURE__ */ e("span", { style: { paddingRight: "10px" }, children: c("common:text.login_no_user") }),
            /* @__PURE__ */ e(ne, { underline: "hover", onClick: a, href: "#", children: c("common:text.login_sign_up") })
          ] })
        ]
      }
    ) })
  ] });
}, Ke = Ve(null), rn = Fe(Ee)(({ theme: r }) => ({
  "&.selected": {
    border: "1px solid " + r.palette.secondary.main + " !important",
    boxShadow: "0px 0px 5px 0px " + Z(r.palette.secondary.main, 0.75)
  },
  "&:hover": {
    border: "1px solid " + K(r.palette.secondary.main, 0.5)
  },
  height: "100%",
  "& .MuiCardActionArea-root": {
    height: "100%",
    "& .MuiCardContent-root": {
      height: "100%",
      paddingTop: 5
    }
  },
  "& .MuiTouchRipple-root": {
    display: "none"
  }
})), Nn = ({
  name: r,
  descriptionType: n,
  description: t,
  moreInformation: i,
  value: a,
  ...o
}) => {
  const c = X(Ke), [l, s] = k(a === (c == null ? void 0 : c.selectedValue));
  return z(() => {
    s(a === (c == null ? void 0 : c.selectedValue));
  }, [c]), /* @__PURE__ */ e(x, { item: !0, ...o, children: /* @__PURE__ */ e(rn, { variant: "outlined", className: `${l && "selected"}`, children: /* @__PURE__ */ e(je, { onClick: () => c == null ? void 0 : c.setSelectedValue(a), children: /* @__PURE__ */ d(ht, { children: [
    /* @__PURE__ */ d(x, { container: !0, alignItems: "center", children: [
      /* @__PURE__ */ e(
        E,
        {
          checked: l,
          sx: { paddingLeft: 0 }
        }
      ),
      /* @__PURE__ */ e(M, { variant: "h6", component: "span", children: r })
    ] }),
    /* @__PURE__ */ d(T, { children: [
      /* @__PURE__ */ d(M, { component: "span", variant: "body2", color: "textSecondary", children: [
        n == "markdown" && /* @__PURE__ */ e(qe, { content: t }),
        n == "html" && /* @__PURE__ */ e(tn, { html: t })
      ] }),
      i && /* @__PURE__ */ e(
        T,
        {
          direction: "row",
          justifyContent: "flex-end",
          children: /* @__PURE__ */ e(
            O,
            {
              href: i.link,
              target: "_blank",
              rel: "noopener noreferrer",
              children: i.label
            }
          )
        }
      )
    ] })
  ] }) }) }) });
}, Gn = ({
  children: r,
  value: n,
  onChange: t,
  ...i
}) => {
  const [a, o] = k(n);
  z(() => {
    o(n);
  }, [n]);
  const c = (l) => {
    t(l);
  };
  return /* @__PURE__ */ e(Ke.Provider, { value: {
    selectedValue: a,
    setSelectedValue: c
  }, children: /* @__PURE__ */ e(x, { container: !0, ...i, children: r }) });
}, Vn = ({
  headerComponent: r,
  actions: n
}) => {
  var s, m, u, g;
  const { t } = $(), i = D(), [a, o] = k(null), c = (p) => {
    o(p.currentTarget);
  }, l = () => {
    o(null);
  };
  return /* @__PURE__ */ d(F, { children: [
    /* @__PURE__ */ e(
      O,
      {
        variant: "outlined",
        color: (g = (u = (m = (s = i.custom) == null ? void 0 : s.components) == null ? void 0 : m.languageSelect) == null ? void 0 : u.buttonStyle) == null ? void 0 : g.color,
        onClick: c,
        startIcon: /* @__PURE__ */ e(Vt, {}),
        children: t("common:text.profile_title")
      }
    ),
    /* @__PURE__ */ d(
      He,
      {
        open: !!a,
        anchorEl: a,
        onClose: l,
        children: [
          /* @__PURE__ */ e(
            b,
            {
              sx: { paddingLeft: 2, paddingRight: 2 },
              children: r
            }
          ),
          /* @__PURE__ */ e(
            H,
            {
              variant: "outlined",
              sx: {
                overflow: "hidden",
                marginLeft: 1,
                marginRight: 1,
                ...r && { marginTop: 1 }
              },
              children: n.map((p, y) => p && /* @__PURE__ */ d(
                Ue,
                {
                  value: y,
                  onClick: () => {
                    p.onClick(), l();
                  },
                  children: [
                    /* @__PURE__ */ d(T, { direction: "row", alignItems: "center", children: [
                      /* @__PURE__ */ e(b, { p: 1, display: "flex", alignItems: "center", children: p.icon }),
                      p.label
                    ] }),
                    /* @__PURE__ */ e(re, {})
                  ]
                },
                y
              ))
            }
          )
        ]
      }
    )
  ] });
}, Te = ({
  name: r,
  loading: n
}) => n ? /* @__PURE__ */ e(te, { variant: "circular", width: 40, height: 40 }) : /* @__PURE__ */ e(pt, { alt: r, children: r[0] }), Xn = ({
  avatarPosition: r = "left",
  name: n,
  email: t,
  loading: i = !1
}) => /* @__PURE__ */ d(
  T,
  {
    direction: "row",
    className: "toolbar-app-name",
    alignItems: "center",
    justifyContent: "center",
    children: [
      /* @__PURE__ */ e(b, { sx: { marginRight: 1 }, children: r === "left" && /* @__PURE__ */ e(Te, { loading: i, name: n }) }),
      /* @__PURE__ */ e(T, { direction: "column", width: "100%", children: i ? /* @__PURE__ */ d(F, { children: [
        /* @__PURE__ */ e(te, { variant: "text", sx: { fontSize: "18px" } }),
        /* @__PURE__ */ e(te, { variant: "text", sx: { fontSize: "14px" } })
      ] }) : /* @__PURE__ */ d(F, { children: [
        /* @__PURE__ */ e(M, { sx: { fontWeight: "bold", fontSize: "18px" }, children: n }),
        /* @__PURE__ */ e(M, { sx: { fontSize: "14px", fontStyle: "italic" }, children: t })
      ] }) }),
      /* @__PURE__ */ e(b, { sx: { marginLeft: 1 }, children: r === "right" && /* @__PURE__ */ e(Te, { loading: i, name: n }) })
    ]
  }
), on = Fe(gt)(({ theme: r }) => {
  var n, t;
  return Xt.merge(
    {
      "& .toolbar-app-name, & .toolbar-icon-button": {
        color: (t = (n = r.custom) == null ? void 0 : n.constants) == null ? void 0 : t.appBarTextColor
      }
    },
    {}
  );
}), Ze = ({
  children: r,
  ...n
}) => /* @__PURE__ */ e(on, { position: "static", ...n, children: r }), an = (r) => {
  var i, a, o, c;
  const { i18n: n } = $(), t = D();
  return /* @__PURE__ */ e(
    "a",
    {
      href: n.exists("common:links.logo") ? n.t("common:links.logo") : void 0,
      target: "_blank",
      style: {
        maxWidth: "70vw",
        display: "flex",
        alignItems: "center",
        height: (a = (i = t.custom) == null ? void 0 : i.constants) == null ? void 0 : a.logoBarMaxHeightImage
      },
      children: /* @__PURE__ */ e(Je, { image: (c = (o = t.custom) == null ? void 0 : o.constants) == null ? void 0 : c.logoBarImage, ...r })
    }
  );
}, Q = Ve({
  open: !1,
  changeOpen: () => {
  }
}), $e = ({
  children: r
}) => {
  const [n, t] = k(!1), i = (a) => {
    t(a);
  };
  return /* @__PURE__ */ e(
    Q.Provider,
    {
      value: { open: n, changeOpen: i },
      children: r
    }
  );
}, J = ({
  showDrawerButton: r,
  mainItems: n,
  extraItems: t
}) => {
  var y, C, v, _;
  const { t: i } = $(), a = D(), [o, c] = k(["upXs"]), l = q(a.breakpoints.up("lg")), s = q(a.breakpoints.up("sm")), m = q(a.breakpoints.up("xs")), { changeOpen: u } = X(Q), g = () => l ? ["upXs", "upSm", "upLg"] : s ? ["upXs", "upSm"] : m ? ["upXs"] : ["upXs"];
  return z(() => {
    c(g());
  }, [l, s, m]), /* @__PURE__ */ e(Ze, { children: /* @__PURE__ */ e(We, { sx: { justifyContent: "center", display: "flex", flexGrow: 1 }, children: /* @__PURE__ */ d(T, { direction: "row", alignItems: "center", sx: { display: "flex", flexGrow: 1, height: "100%" }, children: [
    r && /* @__PURE__ */ e(
      U,
      {
        edge: "start",
        color: "inherit",
        onClick: () => {
          u(!0);
        },
        className: "toolbar-icon-button",
        children: /* @__PURE__ */ e(Ot, {})
      }
    ),
    /* @__PURE__ */ d(T, { direction: "row", justifyContent: "space-around", spacing: 2, sx: { height: "100%", width: "100%" }, children: [
      /* @__PURE__ */ e(an, { text: i("common:text.title") }),
      /* @__PURE__ */ e(
        T,
        {
          spacing: 2,
          direction: "row",
          alignItems: "center",
          justifyContent: ((_ = (v = (C = (y = a.custom) == null ? void 0 : y.components) == null ? void 0 : C.appBar) == null ? void 0 : v.buttons) == null ? void 0 : _.justifyContent) ?? "flex-end",
          width: "100%",
          children: o.map(
            (h) => /* @__PURE__ */ e(Re.Fragment, { children: n[h] }, h)
          )
        }
      ),
      t && /* @__PURE__ */ e(T, { spacing: 2, direction: "row", alignItems: "center", justifyContent: "flex-end", children: o.map(
        (h) => /* @__PURE__ */ e(Re.Fragment, { children: t[h] }, h)
      ) })
    ] })
  ] }) }) });
}, cn = ({
  children: r
}) => /* @__PURE__ */ e(Ze, { children: /* @__PURE__ */ e(
  We,
  {
    sx: {
      flexDirection: "column",
      alignItems: "flex-start",
      padding: 2,
      boxSizing: "border-box"
    },
    children: r
  }
) }), sn = xt(De)(() => Qt(
  //{ theme }
  {
    "& .DrawerItems-container-root": {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      // [theme.breakpoints.up('sm')]: {
      paddingLeft: 8,
      paddingRight: 8
      // }
    }
  },
  {}
)), Ae = ({
  items: r,
  bottomItems: n,
  headerChildren: t,
  ...i
}) => {
  const { open: a, changeOpen: o } = X(Q);
  return /* @__PURE__ */ e(sn, { open: a, onClose: () => {
    o(!1);
  }, ...i, children: /* @__PURE__ */ d(
    b,
    {
      sx: {
        maxWidth: "80vw",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1
      },
      children: [
        /* @__PURE__ */ e(
          cn,
          {
            children: t
          }
        ),
        /* @__PURE__ */ d(b, { className: "DrawerItems-container-root", children: [
          /* @__PURE__ */ e(V, { sx: { flexGrow: 1 }, children: r }),
          n && /* @__PURE__ */ d(F, { children: [
            /* @__PURE__ */ e(re, {}),
            /* @__PURE__ */ e(V, { children: n })
          ] })
        ] })
      ]
    }
  ) });
}, Qn = ({
  orientation: r = "vertical",
  headerProps: n,
  drawerProps: t
}) => {
  const i = P();
  return /* @__PURE__ */ e("header", { role: "banner", children: Qe(i.breakpoints.down("lg")) ? /* @__PURE__ */ d($e, { children: [
    /* @__PURE__ */ e(Ae, { ...t, children: t.items }),
    /* @__PURE__ */ e(
      J,
      {
        ...n,
        showDrawerButton: !0
      }
    )
  ] }) : /* @__PURE__ */ d(F, { children: [
    r === "vertical" && /* @__PURE__ */ d($e, { children: [
      /* @__PURE__ */ e(Ae, { ...t, children: t.items }),
      /* @__PURE__ */ e(
        J,
        {
          ...n,
          showDrawerButton: !0
        }
      )
    ] }),
    r === "horizontal" && /* @__PURE__ */ e(F, { children: /* @__PURE__ */ e(J, { ...n }) })
  ] }) });
}, ln = ({
  children: r,
  title: n,
  ...t
}) => /* @__PURE__ */ e(
  ze,
  {
    title: n,
    ...t,
    children: r
  }
), Oe = {
  title: "",
  placement: "right",
  arrow: !0,
  slotProps: {
    popper: {
      modifiers: [{
        name: "offset",
        options: { offset: [0, -10] }
      }]
    }
  }
}, dn = ({
  icon: r,
  label: n,
  selected: t = !1,
  disabled: i = !1,
  showTooltip: a = !1,
  toolTipProps: o = Oe,
  onClick: c,
  ...l
}) => {
  var m, u;
  const s = D();
  return /* @__PURE__ */ e(Yt, { disablePadding: !0, ...l, sx: { paddingBottom: 1 }, children: /* @__PURE__ */ e(
    ln,
    {
      ...Oe,
      ...o,
      disableFocusListener: !a,
      disableHoverListener: !a,
      disableTouchListener: !a,
      children: /* @__PURE__ */ e("span", { style: { width: "100%" }, children: /* @__PURE__ */ d(
        oe,
        {
          onClick: c,
          selected: t,
          disabled: i,
          sx: {
            ...t && {
              border: `1px solid ${G[300]}`,
              borderRadius: (u = (m = s.custom) == null ? void 0 : m.constants) == null ? void 0 : u.borderRadiusMinor
            }
          },
          children: [
            r && /* @__PURE__ */ e(
              Ne,
              {
                sx: { color: t ? s.palette.primary.main : void 0 },
                children: r
              }
            ),
            /* @__PURE__ */ e(
              Ge,
              {
                primary: n,
                primaryTypographyProps: {
                  color: t ? s.palette.primary.main : void 0,
                  fontWeight: "medium"
                }
              }
            )
          ]
        }
      ) })
    }
  ) });
}, Yn = ({
  onClick: r,
  ...n
}) => {
  const { changeOpen: t } = X(Q);
  return /* @__PURE__ */ e(dn, { onClick: () => {
    t(!1), r();
  }, ...n });
}, mn = ({
  children: r,
  ...n
}) => /* @__PURE__ */ e(V, { ...n, children: r }), un = ({
  children: r,
  icon: n,
  titleLabel: t,
  startOpen: i = !1
}) => {
  const [a, o] = k(i);
  return /* @__PURE__ */ d(F, { children: [
    /* @__PURE__ */ d(oe, { onClick: () => {
      o(!a);
    }, sx: { ...a && { backgroundColor: G[200] } }, children: [
      n && /* @__PURE__ */ e(Ne, { children: n }),
      /* @__PURE__ */ e(
        Ge,
        {
          primary: t,
          primaryTypographyProps: {
            fontWeight: "medium"
          }
        }
      ),
      a ? /* @__PURE__ */ e(Ft, {}) : /* @__PURE__ */ e(Pt, {})
    ] }),
    /* @__PURE__ */ e(yt, { in: a, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ d(T, { direction: "row", children: [
      /* @__PURE__ */ e(re, { orientation: "vertical", flexItem: !0, sx: { marginLeft: 1, marginRight: 1, borderRightWidth: "small" } }),
      /* @__PURE__ */ e(mn, { component: "div", disablePadding: !0, sx: { marginTop: 1, flexGrow: 1 }, children: r })
    ] }) }),
    /* @__PURE__ */ e(b, { sx: { marginBottom: 1 } })
  ] });
}, et = ({
  lang: r,
  isSelected: n
}) => {
  const t = D();
  return /* @__PURE__ */ d(b, { sx: {
    height: 36,
    width: 1,
    display: "flex"
  }, children: [
    n && /* @__PURE__ */ e(b, { sx: { width: 8, height: 1, backgroundColor: t.palette.primary.main } }),
    /* @__PURE__ */ d(
      b,
      {
        sx: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "row",
          ...n && { backgroundColor: ee(t.palette.primary.main, 0.9) }
        },
        children: [
          /* @__PURE__ */ e(
            b,
            {
              sx: {
                fontWeight: "bold",
                width: "25%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              children: r.displayShort
            }
          ),
          /* @__PURE__ */ e(
            b,
            {
              sx: {
                display: "flex",
                alignItems: "center"
              },
              children: r.display
            }
          )
        ]
      }
    )
  ] });
}, qn = ({
  currentLanguage: r,
  availableLanguages: n,
  handleLanguageSelect: t
}) => {
  var g, p, y, C;
  const { t: i } = $(), a = D(), [o, c] = k(null), l = !!o, s = (v) => {
    c(v.currentTarget);
  }, m = () => {
    c(null);
  }, u = (v) => {
    t(v), m();
  };
  return /* @__PURE__ */ d(F, { children: [
    /* @__PURE__ */ e(
      O,
      {
        id: "language-select-button",
        color: (C = (y = (p = (g = a.custom) == null ? void 0 : g.components) == null ? void 0 : p.languageSelect) == null ? void 0 : y.buttonStyle) == null ? void 0 : C.color,
        variant: "outlined",
        onClick: s,
        startIcon: /* @__PURE__ */ e(Ye, {}),
        children: r.displayShort
      }
    ),
    /* @__PURE__ */ e(
      He,
      {
        id: "language-select-menu",
        anchorEl: o,
        open: l,
        onClose: m,
        children: /* @__PURE__ */ d(b, { sx: { marginLeft: 1, marginRight: 1 }, children: [
          /* @__PURE__ */ e(b, { sx: { margin: 1, marginTop: 0 }, children: i("common:text.lang_select") }),
          n.map((v, _) => /* @__PURE__ */ e(Ue, { onClick: () => u(v), sx: { padding: 0 }, children: /* @__PURE__ */ e(et, { lang: v, isSelected: r.value === v.value }) }, _))
        ] })
      }
    )
  ] });
}, Jn = ({
  currentLanguage: r,
  availableLanguages: n,
  handleLanguageSelect: t
}) => {
  const { t: i } = $(), a = (o) => {
    t(o);
  };
  return /* @__PURE__ */ e(un, { titleLabel: i("common:text.language"), icon: /* @__PURE__ */ e(Ye, {}), children: n.map((o, c) => /* @__PURE__ */ e(V, { component: "div", disablePadding: !0, children: /* @__PURE__ */ e(oe, { onClick: () => a(o), sx: { padding: 0 }, children: /* @__PURE__ */ e(ft, { sx: { padding: 0 }, children: /* @__PURE__ */ e(et, { lang: o, isSelected: r.value === o.value }) }) }) }, c)) });
}, hn = ({
  children: r,
  ...n
}) => /* @__PURE__ */ e(M, { ...n, children: r }), pn = ({
  label: r = "Upload",
  value: n = { name: "", data: null },
  errorText: t,
  filename: i,
  icon: a = /* @__PURE__ */ e(Et, {}),
  onChange: o,
  accept: c,
  sx: l
}) => {
  var p;
  const [s, m] = k(n), u = (y) => {
    var C;
    (C = y.target.files) != null && C[0] ? (m({ name: i ?? y.target.files[0].name, data: y.target.files[0] }), o({ name: i ?? y.target.files[0].name, data: y.target.files[0] })) : (m(null), o(null));
  }, g = () => {
    m(null), o(null);
  };
  return /* @__PURE__ */ d(b, { sx: { display: "flex", flexWrap: "wrap", ...l }, children: [
    /* @__PURE__ */ d(
      O,
      {
        variant: "text",
        component: "label",
        children: [
          s ? /* @__PURE__ */ e(Dt, {}) : a,
          /* @__PURE__ */ e(hn, { variant: "caption", sx: { mr: 5, ml: 5 }, children: r }),
          /* @__PURE__ */ e(
            "input",
            {
              type: "file",
              style: { display: "none" },
              onChange: u,
              accept: c
            }
          )
        ]
      }
    ),
    s && /* @__PURE__ */ d("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ e("div", { style: { padding: "8px" }, children: (p = s.data) == null ? void 0 : p.name }),
      /* @__PURE__ */ e(O, { onClick: g, children: /* @__PURE__ */ e(zt, {}) })
    ] }),
    t && /* @__PURE__ */ e("div", { style: { padding: "8px", color: nt[500] }, children: t })
  ] });
}, Kn = ({
  min: r = 1,
  max: n = 5,
  value: t = [{ name: "Invoice0", data: null }],
  onChange: i,
  anotherLabel: a = "Add",
  removeLabel: o = "Remove",
  accept: c,
  filesizeLimit: l = 15e6,
  filename: s,
  hint: m
}) => {
  const { t: u } = $(), [g, p] = k(t), y = (h) => {
    var w;
    let f = [...g];
    const S = f.find((A) => (A == null ? void 0 : A.name) === (h == null ? void 0 : h.name));
    S && (S.data = (h == null ? void 0 : h.data) ?? null, S.error = (w = h == null ? void 0 : h.data) != null && w.size && h.data.size > l ? u("common:text.file_too_large", { amount: l }) : void 0), i(f.filter((A) => A.data !== null));
  }, C = () => {
    const h = [...g];
    h.push({ name: `${s}${g.length}`, data: null }), p(h);
  }, v = () => {
    const h = [...g];
    h.pop(), p(h), t && i(h.filter((f) => f.data !== null));
  }, _ = g.map((h, f) => {
    let S;
    return g.length > r ? f > 0 ? S = `${a} - ${s}${f + 1}` : S = `${s} - ${f + 1}` : S = s, /* @__PURE__ */ d("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ e(
        pn,
        {
          label: S,
          errorText: h == null ? void 0 : h.error,
          onChange: y,
          value: h ?? null,
          filename: s + f,
          accept: c
        }
      ),
      f + 1 > r && f + 1 === g.length && /* @__PURE__ */ d(O, { onClick: v, children: [
        /* @__PURE__ */ e(jt, {}),
        /* @__PURE__ */ e("div", { style: { fontSize: 12 }, children: o })
      ] })
    ] }, f);
  });
  return /* @__PURE__ */ d("div", { children: [
    _,
    g.length < n && /* @__PURE__ */ d(
      O,
      {
        variant: "text",
        onClick: C,
        children: [
          /* @__PURE__ */ e(Ht, {}),
          /* @__PURE__ */ e("div", { style: { fontSize: 12 }, children: a })
        ]
      }
    ),
    m && /* @__PURE__ */ e("div", { className: "helper-text", children: m })
  ] });
}, Zn = Ct(
  function(n, t) {
    const { onChange: i, ...a } = n;
    return /* @__PURE__ */ e(
      qt,
      {
        ...a,
        getInputRef: t,
        onValueChange: (o) => {
          i({
            target: {
              name: n.name,
              value: o.value
            }
          });
        }
      }
    );
  }
), er = ({
  itemsTotal: r,
  itemsPerPage: n,
  currentPage: t = 1,
  onPageChange: i,
  ...a
}) => {
  const [o, c] = k(t), l = Math.ceil(r / n);
  return z(() => {
    const m = {
      first: n * (o - 1),
      last: Math.min(n * (o - 1) + n, r)
    };
    i(
      m,
      o,
      !!r && o > l
    );
  }, [o, n]), z(() => {
    c(t);
  }, [t]), /* @__PURE__ */ e(bt, { count: l, page: o, onChange: (m, u) => {
    c(u);
  }, ...a });
};
export {
  jn as Back,
  O as Button,
  Pn as CookieAcceptDialog,
  Dn as CookiePersonalizeDialog,
  en as CopyElement,
  Yn as DrawerItem,
  Q as DrawerOpenContext,
  $e as DrawerState,
  En as DualLabelSwitch,
  Hn as ElementHover,
  Kn as FileMultiUploadList,
  pn as FileUpload,
  Jn as LanguageListItem,
  qn as LanguageSelect,
  un as ListGroup,
  dn as ListItem,
  Wn as Login,
  Je as Logo,
  an as LogoBar,
  Qn as NavigateMenu,
  Zn as NumericFormatField,
  er as Pagination,
  Un as PublicityBanner,
  qe as RichContent,
  tn as RichHTML,
  Nn as SelectCard,
  Gn as SelectCardGroup,
  zn as SmartTable,
  ln as Tooltip,
  Xn as UserInfo,
  Vn as UserProfileMenu,
  Fn as createBoilerplateTheme
};
//# sourceMappingURL=ov-components.js.map
